import { Link, router } from "@inertiajs/react"
import { AppLayout } from "@/layouts/AppLayout"
import { formatDate } from "@/utils/helpers"
import type { Recipe } from "@/types/models"

interface Props {
  recipes: Recipe[]
}

export default function RecipesIndex({ recipes }: Props) {
  function handleToggleHidden(recipe: Recipe) {
    router.patch(`/admin/recipes/${recipe.id}/toggle_hidden`)
  }

  return (
    <AppLayout title="Recipes">
      <main className="admin-recipes space-y-6">
        <header className="flex items-center justify-between">
          <h1 className="text-2xl font-bold text-slate-900">Recipes</h1>
          <Link
            href="/admin/sources"
            className="rounded-lg bg-slate-900 px-4 py-2 text-sm font-medium text-white hover:bg-slate-800"
          >
            Sources
          </Link>
        </header>

        {recipes.length > 0 ? (
          <div className="overflow-x-auto rounded-lg bg-white shadow-sm ring-1 ring-slate-200">
            <table className="w-full text-left text-sm">
              <thead className="border-b border-slate-200 bg-slate-50 text-xs uppercase text-slate-500">
                <tr>
                  <th className="px-4 py-3">Title</th>
                  <th className="px-4 py-3">Source</th>
                  <th className="px-4 py-3">Published</th>
                  <th className="px-4 py-3 text-right">Pinterest</th>
                  <th className="px-4 py-3">Hidden</th>
                  <th className="px-4 py-3"></th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {recipes.map((recipe) => (
                  <tr key={recipe.id}>
                    <td className="px-4 py-3">
                      <a
                        href={recipe.url}
                        target="_blank"
                        rel="noopener"
                        className="font-medium text-slate-900 hover:text-blue-600 hover:underline"
                      >
                        {recipe.title.length > 50
                          ? recipe.title.slice(0, 50) + "..."
                          : recipe.title}
                      </a>
                    </td>
                    <td className="px-4 py-3 text-slate-600">
                      {recipe.source?.name || recipe.source?.host}
                    </td>
                    <td className="px-4 py-3 text-slate-500">
                      {formatDate(recipe.publishedAt || recipe.discoveredAt)}
                    </td>
                    <td className="px-4 py-3 text-right text-slate-600">
                      {recipe.pinterestCount.toLocaleString()}
                    </td>
                    <td className="px-4 py-3">
                      <span
                        className={`inline-flex items-center rounded-full px-2 py-1 text-xs font-medium ${
                          recipe.hidden
                            ? "bg-amber-100 text-amber-700"
                            : "bg-slate-100 text-slate-600"
                        }`}
                      >
                        {recipe.hidden ? "Yes" : "No"}
                      </span>
                    </td>
                    <td className="px-4 py-3">
                      <button
                        onClick={() => handleToggleHidden(recipe)}
                        className="text-sm text-slate-600 hover:text-slate-900"
                      >
                        {recipe.hidden ? "Unhide" : "Hide"}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="rounded-lg bg-white p-6 text-slate-500 shadow-sm ring-1 ring-slate-200">
            No recipes ingested yet.
          </p>
        )}
      </main>
    </AppLayout>
  )
}
